module.exports = __webpack_public_path__ + "img/green-button-sample.869142df.svg";